import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalVideo from 'react-modal-video';
import Button from '../../components/Button';

import shapeImg1 from '../../assets/img/choose/shape-1-2.png';
import shapeImg2 from '../../assets/img/choose/shape-1-1.png';
import chooseImg from '../../assets/img/choose/choose-1-1.jpg';

const ChooseUs = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div id="it-choose" className="it-choose-area p-relative fix pt-120 pb-120">
      <ModalVideo
        channel="youtube"
        isOpen={isOpen}
        videoId="PO_fBTkoznc"
        onClose={() => openModal()}
      />
      <div className="it-choose-shape-2 d-none d-xl-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-7 col-lg-7">
            <div className="it-choose-left">
              <div className="it-choose-title-box mb-20">
                <span className="it-section-subtitle">Why choose Us</span>
                <h3 className="it-section-title">
                  We Are Always Open For Your <br />
                  Health <span>Services.</span>
                </h3>
              </div>
              <div className="it-choose-text mb-25">
                <p>
                  Neque porro quisquam est, qui dolorem ipsum quia dolor sit
                  amet, consectetur, <br /> adipisci velit, sed quia non numquam
                  eius modi tempora incidunt ut labore et <br /> dolore magnam
                  aliquam quaerat voluptatem.
                </p>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="it-choose-staff blue-color style-1 d-inline-flex align-items-center">
                    <div className="it-choose-staff-icon">
                      <span>
                        <i className="flaticon-doctor"></i>
                      </span>
                    </div>
                    <div className="it-choose-staff-text">
                      <h6 className="it-choose-staff-title">
                        Qualified Doctors
                      </h6>
                      <p className="mb-0">
                        Standard dummy text ever <br /> since the unknown
                        printer took.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="it-choose-staff blue-color style-2 d-inline-flex align-items-center">
                    <div className="it-choose-staff-icon">
                      <span>
                        <i className="flaticon-teamwork"></i>
                      </span>
                    </div>
                    <div className="it-choose-staff-text">
                      <h6 className="it-choose-staff-title">
                        Staff Availability
                      </h6>
                      <p className="mb-0">
                        Standard dummy text ever <br /> since the unknown
                        printer took.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="it-service-button mt-40">
                <Link className="it-btn-theme" to="/about-us">
                  <Button btnText="Learn More" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-5 col-lg-5">
            <div className="it-choose-right text-lg-start text-center p-relative">
              <div className="it-choose-thumb p-relative">
                <img src={chooseImg} alt="" />
                <Link
                  className="it-choose-play pulse popup-video"
                  to="#"
                  onClick={() => openModal()}
                >
                  <i className="fa-sharp fa-solid fa-play"></i>
                </Link>
              </div>
              <div className="it-choose-experience d-flex align-items-center">
                <h6>
                  25+ <br />
                  Years
                </h6>
                <span>
                  of experience in <br />
                  Hospital services
                </span>
              </div>
              <div className="it-choose-shape-1 d-none d-xl-block">
                <img src={shapeImg2} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseUs;
